import { InFilterDefinition } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

export const useAccessStatusFilter = (): InFilterDefinition<string> => {
  return {
    label: i18n.t('employees.employees_list.filters.employee_status'),
    type: 'in' as const,
    options: {
      cache: true,
      options: async () => [
        { label: i18n.t('employees.employees_list.status.active'), value: 'active' },
        { label: i18n.t('employees.employees_list.status.invited'), value: 'invited' },
        { label: i18n.t('employees.employees_list.status.accepted'), value: 'accepted' },
        { label: i18n.t('employees.employees_list.status.not_invited'), value: 'not_invited' },
        { label: i18n.t('employees.employees_list.status.terminated'), value: 'terminated' },
      ],
    },
  }
}
